import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SHARED_IMPORTS } from '../shared-imports';

@Component({
  selector: 'app-title-bar',
  imports: [...SHARED_IMPORTS],
  templateUrl: './title-bar.html',
  styleUrl: './title-bar.scss',
})
export class TitleBar {
  private readonly router = inject(Router);

  get titleKey(): string {
    return this.router.url.startsWith('/chat-') ? 'text.chatTitle' : 'text.title';
  }
}
